export function convert12HrsTimeFormat(hours: number): string {
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    return `${formattedHours} ${period}`;
  }


// WEBPACK FOOTER //
// ./src/components/pages/admin/helperFunctions/timeFunctions.tsx